import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MessageService} from 'primeng/api';
import {ConstantsService} from "@app/core/services/constants.service";

@Injectable({
  providedIn: 'root'
})
export class WavenetToastService {
    constructor(private messageService: MessageService, private translateService: TranslateService, public constantsService: ConstantsService) {}

    public showSuccessToast(summaryKey: string, detailsKey?: string, e?: any, summaryInterpolateParams?: Object, detailsInterpolateParams?: Object): void {
      this.showToast(summaryKey, 'success', detailsKey, e, summaryInterpolateParams, detailsInterpolateParams);
    }
    public showInfoToast(summaryKey: string, detailsKey?: string, e?: any, summaryInterpolateParams?: Object, detailsInterpolateParams?: Object): void {
      this.showToast(summaryKey, 'info', detailsKey, e, summaryInterpolateParams, detailsInterpolateParams);
    }
    public showWarningToast(summaryKey: string, detailsKey?: string, e?: any, summaryInterpolateParams?: Object, detailsInterpolateParams?: Object): void {
      this.showToast(summaryKey, 'warn', detailsKey, e, summaryInterpolateParams, detailsInterpolateParams);
    }

    public showErrorToast(summaryKey: string, detailsKey?: string, e?: any, summaryInterpolateParams?: Object, detailsInterpolateParams?: Object): void {
      this.showToast(summaryKey, 'error', detailsKey, e, summaryInterpolateParams, detailsInterpolateParams);
    }

    private showToast(summaryKey: string, severity: string, e?: any, detailsKey?: string, summaryInterpolateParams?: Object, detailsInterpolateParams?: Object){
      const summary = this.translateService.instant(summaryKey, summaryInterpolateParams);
      if (detailsKey) {
        const details = this.translateService.instant(detailsKey, detailsInterpolateParams);
        this.messageService.add({ key: 'globalToast', severity: severity, summary, detail: details, life: this.constantsService.toastLifeTimeMillis });
      } else {
        this.messageService.add({ key: 'globalToast', severity: severity, summary, life: this.constantsService.toastLifeTimeMillis });
      }
      if (e) {
        console.error(e);
      }
  }
}